module.exports = __webpack_public_path__ + "static/media/menu.91a7fd5d.png";